/**
 * Light / dark, as one button.
 *
 * `toggleTheme` from the design system resolves `system` against the OS setting first, so one
 * press always visibly changes something — which is what a single toggle has to do. The stored
 * preference survives a reload; `ThemeProvider` owns that.
 */
import { IconButton } from '@catalog/ui';
import { useTheme } from '@catalog/ui';

export function ThemeToggle() {
  const { resolvedTheme, toggleTheme } = useTheme();
  const next = resolvedTheme === 'dark' ? 'light' : 'dark';

  return (
    <IconButton
      variant="ghost"
      label={`Switch to ${next} theme`}
      onClick={toggleTheme}
      // The glyph says which theme is active; the accessible name says what pressing it does.
      // Announcing the glyph instead would read as "sun" and tell nobody anything.
      title={`Switch to ${next} theme`}
    >
      <span aria-hidden="true">{resolvedTheme === 'dark' ? '☾' : '☀'}</span>
    </IconButton>
  );
}
